// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { castToFloat } from 'helpers/reduxFormFunctions'

// boils path details form frequency information down for API.
// this supports both custom and channel plans.
// NOTE: frequencies will either be all custom or all a part of a frequency plan.

const formatFrequencyInfo = ({ frequencies, frequencyPlanId }) => (
  frequencies.reduce((a, d, i) => {
    const {
      channelFrequency,
      channelFrequencyId,
      segmentEndFrequencyId,
    } = d

    const polarizationId = castToFloat(d.polarizationId)

    // if channelFrequencyId is truthy, this is from a defined channel plan
    // so we don't need to define the segmentEndFrequency, bc it will come
    // from the defined channel plan.
    // otherwise, if there is no channelFrequencyId, that means it's not from
    // a channel plan and that we need to store its frequency value on segmentEndFrequency
    const segmentEndFrequency = (
      !channelFrequencyId
        ? +channelFrequency
        : null
    )

    // if it doesn't have a polarizationId assigned, that means it's not in use.
    // we only care about frequencies are in use here
    if (polarizationId) {
      a.segmentEndFrequencies.push({
        channelFrequencyId,
        polarizationId,
        segmentEndFrequencyId,
        segmentEndFrequency,
      })
    }
    return a
  }, { frequencyPlanId, segmentEndFrequencies: [] })
)

export default formatFrequencyInfo
